<div class="d-flex flex-column wrapper">
  <label class="label">{{ label }}:</label>
  <mat-chip-grid
    #chipList
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="drop($event)"
    >
    @for (control of targetFormArray.controls; track control; let i = $index) {
      <mat-chip-row
        [removable]="true"
        cdkDrag
        (removed)="removeControl(i)"
        >
        {{ control.value }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    }
    <input
      class="form-control"
      placeholder="Add..."
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
      (matChipInputTokenEnd)="addControl($event)"
      />
    </mat-chip-grid>
  </div>
